import { memo } from 'react';

import { WorkspaceAgentPanelToolGroupLoader } from '~/components/v2/components/workspace/workspace-agent-panel/components/messages/WorkspaceAgentPanelToolGroupLoader';

const WAITING_FOR_USER_LABEL = 'Waiting for user…';

/** The run's line while a choice dock is open: the agent has asked and is waiting on the user's answer. */
export const WorkspaceAgentPanelWaitingForUserLoader = memo(() => (
  <WorkspaceAgentPanelToolGroupLoader
    animate
    className="mt-0.5 size-6 shrink-0"
    data-testid="WORKSPACE_AGENT_TOOL_CALL_GROUP_LOADER"
    text={WAITING_FOR_USER_LABEL}
  />
));

WorkspaceAgentPanelWaitingForUserLoader.displayName = 'WorkspaceAgentPanelWaitingForUserLoader';
